import * as yup from "yup";
import { initializeYup, ReferenceDataCode } from "@duosoftbg/nacid-components";
import { IdentifierType } from "@duosoftbg/nacid-frontoffice-components";
import { RepresentativeType } from "../../../constants/representativeType";
import i18n from "i18next";

export const createBaseUserNameValidationSchema = () => {
  initializeYup(yup);
  const KEYCLOAK_NAME_VALIDATION_REGEX = /^[Ѐ-ӿ\-'. ]*$/;

  const baseUserNameValidationSchema = yup.object({
    firstName: yup.string().required().matches(KEYCLOAK_NAME_VALIDATION_REGEX, i18n.t("validation.field.invalid")),
    middleName: yup.mixed().when(["citizenship", "birthCountry"], {
      is: (citizenship, birthCountry) => citizenship?.id === "BG" && birthCountry?.id === "BG",
      then: yup.string().required(),
      otherwise: yup.string().optional().nullable(),
    }),
    lastName: yup.mixed().when(["citizenship", "personalIdType"], {
      is: (citizenship, personalIdType) => citizenship?.id === "BG" || IdentifierType.NATIONAL_ID === personalIdType,
      then: yup.string().required().matches(KEYCLOAK_NAME_VALIDATION_REGEX, i18n.t("validation.field.invalid")),
      otherwise: yup.string().optional().nullable(),
    }),
  });
  return baseUserNameValidationSchema;
};

export const createBaseUserEmailValidationSchema = () => {
  initializeYup(yup);

  const baseUserEmailValidationSchema = yup.object({
    email: yup.string().required(),
  });
  return baseUserEmailValidationSchema;
};

export const createBaseUsernameValidationSchema = () => {
  initializeYup(yup);

  const baseUsernameValidationSchema = yup.object({
    username: yup.string().required(),
  });
  return baseUsernameValidationSchema;
};

export const createBaseUserValidationSchema = () => {
  initializeYup(yup);

  const baseUserValidationSchema = yup
    .object({
      personalIdType: yup.mixed().oneOf(Object.values(IdentifierType)),
      personalId: yup.string().when(["personalIdType", "foreignerIdentifierKind"], {
        is: (personalIdType, foreignerIdentifierKind) =>
          personalIdType === IdentifierType.DOCUMENT_ID &&
          ReferenceDataCode.FOREIGN_IDENTIFIER_TYPE_NACID_GENERATED === foreignerIdentifierKind?.id,
        then: yup.string().optional(),
        otherwise: yup.string().required(),
      }),
      foreignerIdentifierKind: yup.object().when(["personalIdType"], {
        is: (personalIdType) => personalIdType === IdentifierType.DOCUMENT_ID,
        then: yup.object().shape({
          id: yup.string().required(),
        }),
      }),
      foreignerIdentifierCountry: yup.object().when(["personalIdType", "foreignerIdentifierKind"], {
        is: (personalIdType, foreignerIdentifierKind) =>
          personalIdType === IdentifierType.DOCUMENT_ID &&
          ReferenceDataCode.FOREIGN_IDENTIFIER_TYPE_NACID_GENERATED !== foreignerIdentifierKind?.id,
        then: yup.object().shape({
          id: yup.string().required(),
        }),
      }),
      representedUniversity: yup.mixed().when(["isRepresentative", "representativeType"], {
        is: (isRepresentative, representativeType) =>
          isRepresentative && representativeType === RepresentativeType.UNIVERSITY_REPRESENTATIVE,
        then: yup.string().required(),
      }),
      representedCompany: yup.mixed().when(["isRepresentative", "representativeType"], {
        is: (isRepresentative, representativeType) =>
          isRepresentative && representativeType === RepresentativeType.COMPANY_REPRESENTATIVE,
        then: yup.string().required(),
      }),
      representativeCapacity: yup.mixed().when(["isRepresentative", "representativeType"], {
        is: (isRepresentative, representativeType) =>
          isRepresentative && representativeType === RepresentativeType.UNIVERSITY_REPRESENTATIVE,
        then: yup.string().required(),
      }),
    })
    .concat(createBaseUserNameValidationSchema());
  return baseUserValidationSchema;
};

export const createUserValidationSchema = () => {
  initializeYup(yup);

  const registrationValidationSchema = yup
    .object({
      password: yup.string().optional().nullable(),
    })
    .concat(createBaseUserValidationSchema())
    .concat(createBaseUserEmailValidationSchema())
    .concat(createBaseUsernameValidationSchema());

  return registrationValidationSchema;
};
